<template>

     <div class="week">

        <div class="left-item">
            <img id="schedule" alt="Yoga By Ian" :src="require('../../assets/headers/ybi-weekly-classes-' + $i18n.locale + '.png')">
            <br />
            {{ $t('txtWeeklyClasses') }}
        </div>

        <div v-for="item in eventData" :key="item.id">

            <img v-bind:src="require('../../assets/weekdays/' + item.day + '-' + $i18n.locale + '.png')" width="130px"/>

            <div v-for="evt in item.events" :key="evt">

                <EventCard class="flex-item"
                    v-bind:id="evt.id"
                    v-bind:time="evt.time"
                    v-bind:name="evt.name"
                    v-bind:studio="evt.studio"
                    v-bind:location="evt.location"
                />

            </div>

        </div>

    </div>

</template>
  
<script setup>

import EventCard from './EventCard.vue';

const eventData = [
    {id: 100, day: "monday", events: [
        // {id:11, time: "07:15 (45 mins)", name:"Indoor Cycling", studio:"Holywell Fitness Centre (Studio 1)", location:"Loughborough University"},
        // {id:12, time: "09:30 (60 mins)", name:"Hatha YOGA", studio:"Belvoir Rd Studio", location:"at 'Yoga in Coalville'"},
        {id:13, time: "12:15 (45 mins)", name:"Les Mills BODYBALANCE", studio:"Sutton Bonington Sports Centre", location:"University of Nottingham"},
        //{id:14, time: "18:00 (60 mins)", name:"Hatha YOGA", studio:"Studio 4", location:"Loughborough Leisure Centre"},
        {id:15, time: "19:45 (60 mins)", name:"Les Mills BODYPUMP", studio:"Sir David Wallace (Studio 1)", location:"Loughborough University"}
    ]},

    {id: 200, day: "tuesday", events: [
        {id:21, time: "11:00 (60 mins)", name:"Low Impact Circuits", studio:"Sutton Bonington Sports Centre", location:"University of Nottingham"},
        {id:22, time: "12:15 (45 mins)", name:"Hatha YOGA", studio:"Sutton Bonington Sports Centre", location:"University of Nottingham"},
        //{id:23, time: "18:00 (45 mins)", name:"Indoor Cycling", studio:"Studio 2", location:"Loughborough Leisure Centre"},
        //{id:24, time: "19:10 (60 mins)", name:"Les Mills BODYPUMP", studio:"Studio 1", location:"Loughborough Leisure Centre"},
        //{id:25, time: "20:15 (45 mins)", name:"Les Mills BODYBALANCE", studio:"Studio 1", location:"Loughborough Leisure Centre"}
    ]},

    {id:300, day: "wednesday", events: [
        // {id:31, time: "07:15 (45 mins)", name:"Indoor Cycling", studio:"Holywell Fitness Centre (Studio 1)", location:"Loughborough University"},
        //{id:32, time: "09:30 (45 mins)", name:"Indoor Cycling", studio:"Studio 2", location:"Loughborough Leisure Centre"},
        {id:33, time: "12:15 (45 mins)", name:"Les Mills BODYPUMP", studio:"Sutton Bonington Sports Centre", location:"University of Nottingham"},
    ]}
];

</script>
    
<style>

    .week {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: left;
        flex-wrap:wrap;
        padding-top: 0px;
        padding-bottom: 20px;
    }

    .left-item {
        width:220px;
        flex-basis:240px;
        margin-right: 30px;
        margin-left: 10px;
        margin-bottom: 30px;
    }

    .left-item img {
        width:220px;
    }

    .flex-item {
        width:200px;
        flex-basis:170px;
    }

    @media screen and (max-width: 600px) {
            
        .week {
            justify-content: center;
        }

    }

</style>
